/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
var RESET_STORE_AFTER_LOGOUT = 'APP_RESET_AFTER_LOGOUT';
export default {
  RESET_STORE_AFTER_LOGOUT: RESET_STORE_AFTER_LOGOUT
};